<template>
    <div>
        <PreSalePlan :readOnly="true" />
    </div>

</template>

<script>
import PreSalePlan from '../preSale-management/preSale-plan/preSale-plan';

export default {
    name: 'infoPreSalePlanList',
    components: {
        PreSalePlan
    },
    data() {
        return {
        };
    },
    mounted() {
    },
    methods: {
    }
};
</script>

<style scoped>
</style>
